var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A5F7",
    d: "M8 56h48V8H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55C7FF",
    d: "M8 39.409L39.409 8H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#417505",
    d: "M8 56l12-20 12 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20 45l2.7-4.5L20 36l-2.7 4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FC056",
    d: "M56 49L44 28 28 56h28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23.5a3.5 3.5 0 003.5 3.5h14a3.5 3.5 0 003.5-3.5 7.5 7.5 0 00-7.5-7.5 7.493 7.493 0 00-6.496 3.763A4.5 4.5 0 0015 23.501",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F1",
    d: "M44 40l3.43-6L44 28l-3.43 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0v12h3V3h9V0zm40 0h12v12h-3V3h-9V0zm12 52v12H52v-3h9v-9h3zM0 52v12h12v-3H3v-9H0z",
    fill: "#545874"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16a7.493 7.493 0 00-6.496 3.763A4.5 4.5 0 0015 23.501a3.5 3.5 0 003.5 3.5h1.91l10.57-10.572A7.465 7.465 0 0028.5 16",
    fill: "#FFF"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjR2NjRIMHoiLz48ZyBmaWxsLXJ1bGU9Im5vbnplcm8iPjxwYXRoIGZpbGw9IiMwMEE1RjciIGQ9Ik04IDU2aDQ4VjhIOHoiLz48cGF0aCBmaWxsPSIjNTVDN0ZGIiBkPSJNOCAzOS40MDlMMzkuNDA5IDhIOHoiLz48cGF0aCBmaWxsPSIjNDE3NTA1IiBkPSJNOCA1NmwxMi0yMCAxMiAyMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMjAgNDVsMi43LTQuNUwyMCAzNmwtMi43IDQuNXoiLz48cGF0aCBmaWxsPSIjOEZDMDU2IiBkPSJNNTYgNDlMNDQgMjggMjggNTZoMjh6Ii8+PHBhdGggZD0iTTE1IDIzLjVhMy41IDMuNSAwIDAgMCAzLjUgMy41aDE0YTMuNSAzLjUgMCAwIDAgMy41LTMuNSA3LjUgNy41IDAgMCAwLTcuNS03LjUgNy40OTMgNy40OTMgMCAwIDAtNi40OTYgMy43NjNBNC41IDQuNSAwIDAgMCAxNSAyMy41MDEiIGZpbGw9IiNFQkVCRUIiLz48cGF0aCBmaWxsPSIjRjBGMUYxIiBkPSJNNDQgNDBsMy40My02TDQ0IDI4bC0zLjQzIDZ6Ii8+PHBhdGggZD0iTTEyIDBIMHYxMmgzVjNoOVYwem00MCAwaDEydjEyaC0zVjNoLTlWMHptMTIgNTJ2MTJINTJ2LTNoOXYtOWgzek0wIDUydjEyaDEydi0zSDN2LTlIMHoiIGZpbGw9IiM1NDU4NzQiLz48cGF0aCBkPSJNMjguNSAxNmE3LjQ5MyA3LjQ5MyAwIDAgMC02LjQ5NiAzLjc2M0E0LjUgNC41IDAgMCAwIDE1IDIzLjUwMWEzLjUgMy41IDAgMCAwIDMuNSAzLjVoMS45MWwxMC41Ny0xMC41NzJBNy40NjUgNy40NjUgMCAwIDAgMjguNSAxNiIgZmlsbD0iI0ZGRiIvPjwvZz48L2c+PC9zdmc+";
export { SvgImages as ReactComponent };